document.addEventListener('DOMContentLoaded', () => {
  // Helper function to handle form submission
  function submitLocalizationForm({ country, language, currency }) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.style.display = 'none';

    const inputs = `
      <input type="hidden" name="_method" value="PUT">
      ${country ? `<input type="hidden" name="country_code" value="${country}">` : ''}
      ${language ? `<input type="hidden" name="language_code" value="${language}">` : ''}
      ${currency ? `<input type="hidden" name="currency_code" value="${currency}">` : ''}
      <input type="hidden" name="return_to" value="${window.location.pathname}">
    `;
    
    form.innerHTML = inputs;
    document.body.appendChild(form);
    form.submit();
  }

  // Get user's location using Shopify's endpoint
  async function getLocation() {
    try {
      console.log('Attempting to fetch location from Shopify endpoint...');
      const response = await fetch('/browsing_context_suggestions.json');
      const data = await response.json();
      console.log('Shopify location data:', data);
      
      // Successfully got location from Shopify
      if (data.detected_values && data.detected_values.country) {
        return {
          country: data.detected_values.country.handle,
          language: data.detected_values.language?.handle || 'en'
        };
      }
      
      // If Shopify data is incomplete, throw error to try fallback
      throw new Error('Incomplete Shopify location data');
      
    } catch (shopifyError) {
      console.log('Shopify endpoint issue:', shopifyError.message);
      // Fallback to freeipapi if Shopify endpoint fails
      try {
        const response = await fetch("https://freeipapi.com/api/json/");
        const data = await response.json();
        console.log('FreeIPAPI data:', data);
        return {
          country: data.countryCode,
          language: data.countryCode === 'FR' ? 'fr' : 'en'
        };
      } catch (error) {
        console.error('Error fetching location:', error);
        // Use current country from Shopify as fallback instead of hardcoded US
        const fallbackCountry = window.currentCountry || 'US';
        const fallbackLanguage = document.documentElement.lang || 'en';
        console.log('Using fallback country:', fallbackCountry);
        return { country: fallbackCountry, language: fallbackLanguage };
      }
    }
  }

  // Check if this is a new session
  function isNewSession() {
    return !sessionStorage.getItem('sessionStarted');
  }

  // Check if we've already redirected for geolocation in this session
  function hasGeoRedirected() {
    return sessionStorage.getItem('geoRedirected') === 'true';
  }

  // Map country codes to currency codes
  function getCurrencyForCountry(country) {
    const currencyMap = {
      'US': 'USD',
      'CA': 'CAD',
      'FR': 'EUR',
      'GB': 'GBP',
      'AU': 'AUD'
    };
    return currencyMap[country] || 'USD';
  }

  // Initialize currency selectors
  function initializeCurrencySelectors(defaultCountry) {
    // Prioritize session storage, then use default country
    const countryToSelect = sessionStorage.getItem('country') || defaultCountry;
    console.log('Initializing currency selector with country:', countryToSelect);

    document.querySelectorAll('.currency-selector select').forEach(select => {
      select.value = countryToSelect;
      console.log('Set currency selector value to:', countryToSelect);
      
      select.addEventListener('change', () => {
        const selectedCountry = select.value;
        const selectedCurrency = getCurrencyForCountry(selectedCountry);
        sessionStorage.setItem('country', selectedCountry);
        // Submit both country and currency codes
        submitLocalizationForm({ 
          country: selectedCountry,
          currency: selectedCurrency 
        });
      });
    });
  }

  // Initialize language selectors
  function initializeLanguageSelectors(defaultLanguage) {
    const savedLanguage = localStorage.getItem('language') || defaultLanguage;
    
    document.querySelectorAll('.language-selector button').forEach(button => {
      const buttonLang = button.getAttribute('data-language');
      button.classList.toggle('active', buttonLang === savedLanguage);
      
      button.addEventListener('click', () => {
        const selectedLanguage = button.getAttribute('data-language');
        localStorage.setItem('language', selectedLanguage);
        submitLocalizationForm({ language: selectedLanguage });
      });
    });
  }

  // Show all localization wrappers
  function showLocalizationWrappers() {
    document.querySelectorAll('.localization-wrapper').forEach(wrapper => {
      wrapper.classList.add('is-visible');
    });
  }

  // Initialize everything
  async function initialize() {
    console.log('Current country from Shopify:', window.currentCountry);
    console.log('Session storage country:', sessionStorage.getItem('country'));
    
    const location = await getLocation();
    const savedLanguage = localStorage.getItem('language');
    
    // If this is a new session...
    if (isNewSession()) {
      sessionStorage.setItem('sessionStarted', 'true');
      
      // Use the detected location for new sessions
      sessionStorage.setItem('country', location.country);
      console.log('New session - setting country to detected location:', location.country);
      
      // If we have a saved language preference, use it, otherwise use detected language
      const languageToUse = savedLanguage || location.language;
      if (!savedLanguage) {
        localStorage.setItem('language', languageToUse);
      }

      // Initialize UI elements after setting session storage
      initializeCurrencySelectors(location.country);
      initializeLanguageSelectors(location.language);
      showLocalizationWrappers();

      // Only redirect if:
      // 1. Current country differs from detected location
      // 2. We haven't already redirected in this session
      if (window.currentCountry !== location.country && !hasGeoRedirected()) {
        console.log('First visit - redirecting from', window.currentCountry, 'to detected country:', location.country);
        sessionStorage.setItem('geoRedirected', 'true');
        
        // Submit form to update prices to correct currency
        submitLocalizationForm({ 
          country: location.country,
          language: languageToUse,
          currency: getCurrencyForCountry(location.country)
        });
      } else if (window.currentCountry !== location.country) {
        console.log('Already redirected once. Current:', window.currentCountry, 'Detected:', location.country);
        console.log('User can manually change currency/country using the selector');
      }
      
      return;
    }
    
    // Not a new session, ensure we have stored values
    if (!sessionStorage.getItem('country')) {
      // Use detected location for consistency
      sessionStorage.setItem('country', location.country);
      console.log('Existing session - setting country to:', location.country);
    }
    
    if (!localStorage.getItem('language')) {
      localStorage.setItem('language', location.language);
    }

    // Initialize UI elements after ensuring session storage is set
    initializeCurrencySelectors(sessionStorage.getItem('country') || location.country);
    initializeLanguageSelectors(localStorage.getItem('language') || location.language);
    showLocalizationWrappers();
  }

  // Currency selector is handled by initializeCurrencySelectors above

  // Locale selector
  document.querySelectorAll('#localeItem').forEach((item) => {
    item.addEventListener('click', (event) => {
      document.getElementById('localeCode').value = item.getAttribute('lang');
      document.getElementById('localization_form').submit();
    });
  });

  initialize();
});